import { render } from "./01_Advisor.vue?vue&type=template&id=1bc4bdc0"
import script from "./01_Advisor.vue?vue&type=script&lang=js"
export * from "./01_Advisor.vue?vue&type=script&lang=js"

import "./01_Advisor.vue?vue&type=style&index=0&id=1bc4bdc0&lang=scss"
script.render = render

export default script